// TODO add comments
import { ArrayUtils, StringUtils, Logger, engineComponent, Utils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { ParticleStyle } from "../Components/Elements/Styles/ParticleStyle";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { AnimationElement } from "../Components/Elements/Graphics/AnimationElement";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { StageController } from "../Components/StageController";
import { StyleManager } from "../Components/Managers/StyleManager";
import { Tweens } from "../Components/Effects/Tweens";
import { CustomUtils } from "../Utils/CustomUtils";

@engineComponent(ComponentTypes.DisplayObject)
export class ParticleElementKDG extends BaseElement {
    // handle definition for particles
    private _style: ParticleStyle;
    private _styleName: string;

    private _image: ImageElement | AnimationElement;
    //  holds particles in pool and reused them
    private _pool: Array<ParticleElementKDG>;
    // container of whole particle element
    private _parent: ParticleElementKDG;
    // container of whole particle element
    private _container: ParticleElementKDG;
    // timer for add particles
    private _timer: FrameTimerEventEmitter;

    private _stopping: boolean;
    private _stop: boolean;
    private _emitOnce: boolean;
    private _startType: string;
    private _randomStartFrame: boolean;
    private _maxEmit: number;

    private _blendMode: number;
    private _created: boolean;

    private _usedInPool: boolean;
    private _isSubParticle: boolean;

    private _level: number;

    constructor() {
        super();

        this._pool = [];

        this._timer = CreateFrameTimer("particleTimer");
        this._timer.on(FrameTimerEvents.Complete, this.addParticles.bind(this));

        this._blendMode = 0;
        this._created = false;
        this._stopping = false;
        this._stop = true;
        this._emitOnce = false;
        this._startType = "";
        this._randomStartFrame = false;
        this._maxEmit = 1;
        this.visible = false;
        this._usedInPool = false;
        this._isSubParticle = false;
        this._parent = null;
        this._container = null;

        this._level = 0;
    }

    createByNode(node: Element): void {
        if (!this._created) {
            super.createByNode(node);

            if (node.hasAttribute(ParticleElementAttributes.BLEND_MODE)) {
                this._blendMode = parseInt(node.getAttribute(ParticleElementAttributes.BLEND_MODE));
            }

            if (node.hasAttribute(ParticleElementAttributes.RANDOM_START_FRAME)) {
                this._randomStartFrame = StringUtils.parseBoolean(
                    node.getAttribute(ParticleElementAttributes.RANDOM_START_FRAME),
                );
            }

            if (node.hasAttribute(ParticleElementAttributes.SUB_PARTICLE)) {
                this._isSubParticle = StringUtils.parseBoolean(
                    node.getAttribute(ParticleElementAttributes.SUB_PARTICLE),
                );
            }

            if (node.hasAttribute(ParticleElementAttributes.LEVEL)) {
                this._level = parseInt(node.getAttribute(ParticleElementAttributes.LEVEL));
            }

            if (
                node.hasAttribute(ParticleElementAttributes.STYLE) ||
                node.hasAttribute(ParticleElementAttributes.STYLE2)
            ) {
                if (node.hasAttribute(ParticleElementAttributes.STYLE)) {
                    this._style = <ParticleStyle>(
                        StyleManager.Styles[node.getAttribute(ParticleElementAttributes.STYLE)]
                    );
                } else {
                    this._style = <ParticleStyle>(
                        StyleManager.Styles[node.getAttribute(ParticleElementAttributes.STYLE2)]
                    );
                }

                this._styleName = this._style.name;
            }

            //if is subParticle, create image representation of particle, otherwise create just child particles
            if (this._isSubParticle) {
                this._image = this.createParticleImage(node);
            } else {
                this._container = this;
                //this._pool = this.createParticles();
                this._pool = [];
            }

            this._created = true;
        }
    }

    updateByNode(node: Element): void {
        if (!this._isSubParticle) {
            if (node.hasAttribute(ParticleElementAttributes.EMIT_ONCE)) {
                this._emitOnce = StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.EMIT_ONCE));
            }

            if (node.hasAttribute(ParticleElementAttributes.MAX_EMIT)) {
                this._maxEmit = parseInt(node.getAttribute(ParticleElementAttributes.MAX_EMIT));
                this._maxEmit = this._maxEmit * 0.01;

                if (this._maxEmit > 1) {
                    this._maxEmit = 1;
                }
            }

            if (node.hasAttribute(ParticleElementAttributes.START_TYPE)) {
                this._startType = node.getAttribute(ParticleElementAttributes.START_TYPE);
            }

            if (
                node.hasAttribute(ParticleElementAttributes.START) &&
                StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.START))
            ) {
                this.start(this._emitOnce, this._startType);
            }

            if (
                node.hasAttribute(ParticleElementAttributes.STOPPING) &&
                StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOPPING))
            ) {
                this.stopping();
            }

            if (
                node.hasAttribute(ParticleElementAttributes.STOP) &&
                StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.STOP))
            ) {
                this.stop();
            }

            if (
                node.hasAttribute(ParticleElementAttributes.RESET) &&
                StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.RESET))
            ) {
                this.reset();
            }

            if (
                node.hasAttribute(ParticleElementAttributes.CLEAR) &&
                StringUtils.parseBoolean(node.getAttribute(ParticleElementAttributes.CLEAR))
            ) {
                this.clear();
            }
        }
    }

    private setVisibility(visible: boolean): void {
        this.visible = visible;
        if (this._image != null) {
            this._image.visible = visible;

            if (this._image instanceof AnimationElement) {
                if (visible) {
                    this._image.playMe();
                } else {
                    this._image.stop();
                }
            }
        }
    }

    private createParticleImage(node: Element): ImageElement | AnimationElement {
        if (node.hasAttribute(ParticleElementAttributes.IMAGE)) {
            let resourceId = node.getAttribute(ParticleElementAttributes.IMAGE);
            let resource: ImageElement | AnimationElement;

            if (resourceId.indexOf("GFX_") > -1) {
                resource = new ImageElement(
                    StageController.getTextureByResourceId(node.getAttribute(ParticleElementAttributes.IMAGE)),
                );
                resource.blendMode = CustomUtils.getBlendMode(this._blendMode);
            } else {
                let node: Element = document.createElement("Animation");
                node.setAttribute("Style2", resourceId);
                node.setAttribute("RandomStartFrame", this._randomStartFrame.toString());
                resource = new AnimationElement();
                resource.create(node);
            }
            let localBounds = resource.getLocalBounds();

            resource.visible = false;

            this.pivot.set(localBounds.width / 2, localBounds.height / 2);
            this.addChild(resource);

            return resource;
        }

        return null;
    }

    public createParticles(): Array<ParticleElementKDG> {
        let pool: Array<ParticleElementKDG> = [];

        if (this._style != null) {
            if (this._style.images != null && this._style.images.length > 0) {
                let count: number = this._style.calculateElements();

                for (let i: number = 0; i < count; i++) {
                    let particleElement = this.createParticle(this._container);
                    pool.push(particleElement);
                }
            }
        }

        return pool;
    }

    private createParticle(container: ParticleElementKDG = null, index: number = -1): ParticleElementKDG {
        let node: Element = this.createParticleNode();
        let particleElement = new ParticleElementKDG();

        particleElement.create(node);
        particleElement._container = container;
        particleElement._parent = this;
        particleElement._pool = particleElement.createParticles();
        particleElement = this.setupParticle(particleElement);

        if (particleElement._container != null) {
            if (index > -1) {
                particleElement._container.addChildAt(particleElement, index);
            } else {
                particleElement._container.addChild(particleElement);
            }
        } else {
            if (index > -1) {
                particleElement.addChildAt(particleElement, index);
            } else {
                particleElement.addChild(particleElement);
            }
        }

        return particleElement;
    }

    private getRandomResource(): string {
        return this._style.images[Math.floor(Math.random() * this._style.images.length)];
    }

    private createParticleNode(): Element {
        let node: Element = document.createElement("Particle_" + this._level);
        node.setAttribute("Image", this.getRandomResource());

        node.setAttribute("BlendMode", this._blendMode + "");
        node.setAttribute("SubParticle", "true");
        node.setAttribute("Level", this._level + 1 + "");
        node.setAttribute("RandomStartFrame", this._style.randomStartFrame.toString());

        if (!StringUtils.isNullOrEmpty(this._style.subParticleStyle)) {
            node.setAttribute("Style", this._style.subParticleStyle);
        }

        return node;
    }

    private setupParticle(particleElement: ParticleElementKDG): ParticleElementKDG {
        particleElement.setVisibility(false);
        particleElement._usedInPool = false;

        return particleElement;
    }

    private setupPosition(particleElement: ParticleElementKDG): ParticleElementKDG {
        let startX = 0;
        let startY = 0;

        switch (this._style.positionZone.type) {
            case ParticleStyle.ZoneRectangle:
                startX = this._style.positionZone.x + Math.random() * this._style.positionZone.width;
                startY = this._style.positionZone.y + Math.random() * this._style.positionZone.height;

                if (this._style.positionZone.innerWidth != -1 && this._style.positionZone.innerHeight != -1) {
                    let centerX = this._style.positionZone.x + this._style.positionZone.width / 2;
                    let centerY = this._style.positionZone.y + this._style.positionZone.height / 2;
                    let innerCenterX = this._style.positionZone.innerX + this._style.positionZone.innerWidth / 2;
                    let innerCenterY = this._style.positionZone.innerY + this._style.positionZone.innerHeight / 2;
                    let correctX = Math.random() > 0.5;

                    if (correctX) {
                        if (startX > centerX) {
                            startX = this.getRandom(
                                innerCenterX + this._style.positionZone.innerWidth * 0.5,
                                centerX + this._style.positionZone.width * 0.5,
                            );
                        } else {
                            startX = this.getRandom(0, innerCenterX - this._style.positionZone.innerWidth * 0.5);
                        }
                    } else {
                        if (startY > centerY) {
                            startY = this.getRandom(
                                innerCenterY + this._style.positionZone.innerHeight * 0.5,
                                centerY + this._style.positionZone.height * 0.5,
                            );
                        } else {
                            startY = this.getRandom(0, innerCenterY - this._style.positionZone.innerHeight * 0.5);
                        }
                    }
                }

                particleElement.position.x = startX;
                particleElement.position.y = startY;

                break;
            case ParticleStyle.ZoneParent:
                particleElement.position.x = this.position.x;
                particleElement.position.y = this.position.y;
                break;
            case ParticleStyle.ZoneLine:
                // TODO
                break;
            case ParticleStyle.ZoneEllipse:
                startX = this._style.positionZone.x;
                startY = this._style.positionZone.y;
                let radianDegrees = Math.floor(
                    this.getRandom(this._style.positionZone.startAngle, this._style.positionZone.angle),
                );
                let radian = this.degrees2radians(radianDegrees);

                //start is not from origin but from another, inner circle
                if (this._style.positionZone.innerRadius > 0) {
                    let radius = this.getRandom(
                        this._style.positionZone.minInnerRadius,
                        this._style.positionZone.innerRadius,
                    );
                    let radiusB = this.getRandom(
                        this._style.positionZone.minInnerRadiusB,
                        this._style.positionZone.innerRadiusB,
                    );

                    startX = Math.floor(this._style.positionZone.innerX + radius * Math.cos(radian));
                    startY = Math.floor(this._style.positionZone.innerY + radiusB * Math.sin(radian));
                }

                particleElement.x = startX;
                particleElement.y = startY;
                particleElement.rotation = radian;

                break;
        }

        return particleElement;
    }

    private addBehaviour(particleElement: ParticleElementKDG): void {
        let particleLife: number =
            Math.floor(Math.random() * (this._style.maxLife - this._style.minLife)) + this._style.minLife;

        this.addPathBehaviour(particleElement, particleLife);
        this.addScaleBehaviour(particleElement, particleLife);
        this.addRotationBehaviour(particleElement, particleLife);
        this.addAlphaBehaviour(particleElement, particleLife);
    }

    private addPathBehaviour(particleElement: ParticleElementKDG, life: number): void {
        switch (this._style.positionZone.type) {
            case ParticleStyle.ZoneRectangle:
            case ParticleStyle.ZoneParent:
                this.addRectanglePathBehavior(particleElement, life);
                break;
            case ParticleStyle.ZoneEllipse:
                this.addEllipsePathBehavior(particleElement, life);
                break;
        }
    }

    private addRectanglePathBehavior(particleElement: ParticleElementKDG, life: number): void {
        if (this._style.pathValues != null) {
            let points: Array<Object> = [];
            for (let i: number = 0; i < this._style.pathValues.length; i++) {
                if (
                    this._style.pathValues[i] != null &&
                    this._style.pathValues[i].x != null &&
                    this._style.pathValues[i].y != null
                ) {
                    let valueX: number = this._style.pathValues[i].x;
                    let valueY: number = this._style.pathValues[i].y;
                    if (this._style.pathValues[i].randomX != null) {
                        valueX =
                            Math.floor(
                                Math.random() * (this._style.pathValues[i].randomX - this._style.pathValues[i].x),
                            ) + this._style.pathValues[i].x;
                    }
                    if (this._style.pathValues[i].randomY != null) {
                        valueY =
                            Math.floor(
                                Math.random() * (this._style.pathValues[i].randomY - this._style.pathValues[i].y),
                            ) + this._style.pathValues[i].y;
                    }
                    points.push({ x: particleElement.x + valueX, y: particleElement.y + valueY });
                }
            }
            if (points.length > 2) {
                Tweens.positionTween(particleElement, {
                    bezier: {
                        values: points,
                    },
                    tweenX: [particleElement.x, particleElement.x],
                    tweenY: [particleElement.y, particleElement.y],
                    tweenDuration: life,
                    paused: false,
                    callbackFunction: this.removeFromPool,
                    callbackParams: [particleElement],
                    callbackScope: null,
                });
            } else if (points.length === 2) {
                Tweens.positionTween(particleElement, {
                    tweenX: [points[0]["x"], points[1]["x"]],
                    tweenY: [points[0]["y"], points[1]["y"]],
                    tweenDuration: life,
                    paused: false,
                    callbackFunction: this.removeFromPool,
                    callbackParams: [particleElement],
                    callbackScope: null,
                });
            }
        }
    }

    private addEllipsePathBehavior(particleElement: ParticleElementKDG, life: number): void {
        let radius = this.getRandom(this._style.positionZone.minRadius, this._style.positionZone.radius);
        let radiusB = this.getRandom(this._style.positionZone.minRadiusB, this._style.positionZone.radiusB);
        let finalX = Math.floor(this._style.positionZone.x + radius * Math.cos(particleElement.rotation));
        let finalY = Math.floor(this._style.positionZone.y + radius * Math.sin(particleElement.rotation));

        Tweens.positionTween(particleElement, {
            tweenX: [particleElement.x, finalX],
            tweenY: [particleElement.y, finalY],
            tweenDuration: life,
            paused: false,
            callbackFunction: this.removeFromPool,
            callbackParams: [particleElement],
            callbackScope: null,
        });
    }

    private addScaleBehaviour(particleElement: ParticleElementKDG, life: number): void {
        if (this._style.scaleValues != null) {
            let scalePoints: Array<PIXI.Point> = [];
            for (let i: number = 0; i < this._style.scaleValues.length; i++) {
                let scaleValue: number;
                if (this._style.scaleValues[i].length > 1) {
                    scaleValue =
                        Math.random() * (this._style.scaleValues[i][1] - this._style.scaleValues[i][0]) +
                        this._style.scaleValues[i][0];
                } else {
                    scaleValue = this._style.scaleValues[i][0];
                }
                if (particleElement._parent != null) {
                    scaleValue *= particleElement._parent.scale.x;
                }
                scalePoints.push(new PIXI.Point(scaleValue, scaleValue));
            }

            if (scalePoints.length === 1) {
                particleElement.scale.x = scalePoints[0].x;
                particleElement.scale.y = scalePoints[0].y;
            } else {
                Tweens.scaleTween(particleElement, {
                    tweenValues: scalePoints,
                    tweenDuration: life,
                    paused: false,
                });
            }
        }
    }

    private addRotationBehaviour(particleElement: ParticleElementKDG, life: number): void {
        if (this._style.rotationValues != null && this._style.rotationValues.length > 1) {
            Tweens.rotationTween(particleElement, {
                degrees: [this._style.rotationValues[0], this._style.rotationValues[1]],
                tweenDuration: life,
                paused: false,
            });
        }
    }

    private addAlphaBehaviour(particleElement: ParticleElementKDG, life: number): void {
        if (this._style.alphaValues != null) {
            let alphas: Array<number> = [];
            for (let i: number = 0; i < this._style.alphaValues.length; i++) {
                alphas.push(this._style.alphaValues[i]);
            }
            Tweens.alphaTween(particleElement, {
                alphas: alphas,
                tweenDuration: life,
                paused: false,
            });
        }
    }

    private addParticles(): void {
        if (!this._stop) {
            let tabActive = true;
            if (document.visibilityState != null && document.visibilityState === "hidden") {
                tabActive = false;
            }

            if (tabActive) {
                this.getFromPool();
            }

            if (!this._stopping) {
                this._timer.start(this._style.time);
            }
        }
    }

    private getFreeParticleIndex(): number {
        for (let i: number = 0; i < this._pool.length; i++) {
            if (!this._pool[i]._usedInPool) {
                return i;
            }
        }

        return -1;
    }

    private getFromPool(): void {
        let count = Math.floor(this._style.count * this._maxEmit);

        for (let i: number = 0; i < count; i++) {
            let particleElement: ParticleElementKDG;
            let index: number = this.getFreeParticleIndex();

            // to keep pool ordered by usedInPool check if first element is usedInPool
            // if yes, create new and push to pool
            // if not, shift element, set usedInPool and push to pool
            if (index == -1) {
                let childIndex = -1;

                //if we want add subParticle we need to know childIndex in container to keep z-index order
                if (this._container != this) {
                    childIndex = this._container.getChildIndex(this);
                }

                particleElement = this.createParticle(this._container, childIndex);
                this._pool.push(particleElement);
            } else {
                particleElement = this._pool[index];
            }

            particleElement._usedInPool = true;
            particleElement.setVisibility(true);
            // Tweens.restartTweens(particle.uid);
            particleElement = this.setupPosition(particleElement);
            this.addBehaviour(particleElement);
            particleElement.start();
        }
    }

    start(emitOnce: boolean = false, startType: string = ""): void {
        this.setVisibility(true);

        //if there is no style, there is no particles to emit
        if (this._style != null) {
            this._emitOnce = emitOnce;
            this._startType = startType;
            this._stopping = emitOnce;
            this._stop = false;
            if (!this._emitOnce) {
                this._timer.start(this._style.time);
                if (this._startType === "now") {
                    this.addParticles();
                }
            } else {
                this.addParticles();
            }
        }
    }

    stopping(): void {
        this._stopping = true;

        for (let i: number = 0; i < this._pool.length; i++) {
            this._pool[i].stopping();
        }
    }

    stop(): void {
        this._stopping = false;
        this._stop = true;
        this._timer.stop();
        this.setVisibility(false);

        for (let i: number = 0; i < this._pool.length; i++) {
            this._pool[i].stop();
            this._pool[i]._usedInPool = false;
            this._pool[i].destroy();
        }
        this._pool = [];
        //this.removeAllFromPool();
    }

    reset(): void {
        for (let i: number = 0; i < this._pool.length; i++) {
            this._pool[i] = this.setupPosition(this._pool[i]);
            this._pool[i].setVisibility(false);
            this._pool[i].reset();
        }
    }

    clear(): void {
        this._stopping = false;
        this._stop = true;
        this._timer.stop();
        this.setVisibility(false);
        this.removeAllFromPool();
    }

    private removeFromPool(particleElement: ParticleElementKDG): void {
        particleElement.setVisibility(false);
        Tweens.removeTweenFromRegistry(particleElement.uid);
        particleElement.stop();
        particleElement._usedInPool = false;
    }

    private removeAllFromPool(): void {
        console.error("removeAllFromPool");
        for (let i: number = 0; i < this._pool.length; i++) {
            this._pool[i].setVisibility(false);
            // Tweens.removeTweens(this._pool[i]);

            this._pool[i]._usedInPool = false;
        }
    }

    private getRandom(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }

    /**
     * Clone method used for cloning instance of this element with his main properties.
     * @method clone
     * @return ParticleElementKDG
     */
    clone(): ParticleElementKDG {
        let element: ParticleElementKDG = new ParticleElementKDG();
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;
        element.visible = this.visible;
        element._blendMode = this._blendMode;
        element._usedInPool = this._usedInPool;
        element._isSubParticle = this._isSubParticle;
        element._level = this._level;
        let node: Element = document.createElement(this.name);
        node.setAttribute("Style2", this._styleName);
        element.create(node);
        element._markAsCloned(); // must be called last before return!
        return element;
    }
}

/**
 * Extended by BaseElementAttributes
 * @type {{TINT: string; BLEND_MODE: string; STYLE: string; STYLE2: string; START: string; EMIT: string; STOPPING: string; STOP: string; ALPHA_TWEEN_EASE: string; ALPHA_TWEEN_DELAY: string; ALPHA_TWEEN_DURATION: string; ROTATION_TWEEN: string; ROTATION_TWEEN_EASE: string; ROTATION_TWEEN_DURATION: string; ROTATION_TWEEN_DELAY: string; SCALE_TWEEN: string; SCALE_TWEEN_EASE: string; SCALE_TWEEN_DURATION: string; POSITION_TWEEN_X: string; POSITION_TWEEN_Y: string; POSITION_TWEEN_EASE: string; POSITION_TWEEN_DURATION: string; POSITION_TWEEN_POSITION: string; POSITION_TWEEN_POSITION_VALUE: {ABSOLUTE: string; RELATIVE: string}}}
 */
export const ParticleElementAttributes = {
    /**
     * Blend mode for animation.
     * Bleding modes:
     *   0 = NORMAL;
     *   1 = ADD;
     *   2 = MULTIPLY;
     *   3 = SCREEN;
     *   4 = OVERLAY;
     *   5 = DARKEN;
     *   6 = LIGHTEN;
     *   7 = COLOR_DODGE;
     *   8 = COLOR_BURN;
     *   9 = HARD_LIGHT;
     *   10 = SOFT_LIGHT;
     *   11 = DIFFERENCE;
     *   12 = EXCLUSION;
     *   13 = HUE;
     *   14 = SATURATION;
     *   15 = COLOR;
     *   16 = LUMINOSITY;
     * @property BlendMode
     * @type number
     * @default null
     */
    BLEND_MODE: "BlendMode",
    /**
     * Random start frame, when animation particles are used
     */
    RANDOM_START_FRAME: "RandomStartFrame",
    SPEED: "Speed",
    EMIT_ONCE: "EmitOnce",
    START_TYPE: "StartType",
    /**
     * How many particles in one fire will be used in percentage. Max 100%
     */
    MAX_EMIT: "MaxEmit",
    // Tweens used in BaseElementParticle
    ALPHA_TWEEN: "AlphaTween",
    ALPHA_TWEEN_EASE: "AlphaTweenEase",
    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",

    POSITION_TWEEN_X: "PositionTweenX",
    POSITION_TWEEN_Y: "PositionTweenY",
    POSITION_TWEEN_EASE: "PositionTweenEase",
    POSITION_TWEEN_DURATION: "PositionTweenDuration",
    POSITION_TWEEN_POSITION: "PositionTweenPosition",
    POSITION_TWEEN_POSITION_VALUE: {
        ABSOLUTE: "absolute",
        RELATIVE: "relative",
    },

    ROTATION_TWEEN: "RotationTween",
    ROTATION_TWEEN_EASE: "RotationTweenEase",
    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
    ROTATION_TWEEN_DELAY: "RotationTweenDelay",

    SCALE_TWEEN: "ScaleTween",
    SCALE_TWEEN_EASE: "ScaleTweenEase",
    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
    /**
     * Style define animation. You can use one style on more than one place.
     * Style for ParticleElementKDG has to be instance of ParticleStyle.
     * @property Style
     * @type string
     * @default null
     */
    STYLE: "Style",
    STYLE2: "Style2",
    EXTEND_STYLE: "ExtendStyle",
    START: "Start",
    STOPPING: "Stopping",
    STOP: "Stop",
    RESET: "Reset",
    CLEAR: "Clear",
    SUB_PARTICLE: "SubParticle",
    IMAGE: "Image",
    LEVEL: "Level",
    /**
     * Tint of animation. Hex color which colorize movie clip.
     * @property Tint
     * @type string
     * @default null
     */
    TINT: "Tint",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ParticleElementKDG.ts
 **/